import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { NgToastService } from 'ng-angular-popup';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router,private toast: NgToastService, private auth: AuthService,) {}
  isMobile: boolean = false;

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    const tokenKeys = ['user-access', 'token', 'user-token-goldBharatFirst'];
    let token = null;
    
    for (const key of tokenKeys) {
      token = localStorage.getItem(key);
      if (token) break;
    }
    
    if (!!token) {
      return true; // User is logged in
    } else {
      this.toast.error({ detail: 'Authentication Required', summary:'Login/Register to the Application' , position: 'topCenter' })
      this.isMobile = this.auth.isMobile();

      if(this.isMobile){
        this.router.navigate(['/mobile/mobileview']);
      }
      else{
        this.router.navigate(['/']);
      }
      return false; // User is not logged in
    }
  }
}